import { render, staticRenderFns } from "./BatchUpdates.vue?vue&type=template&id=cb428fd2&"
import script from "./BatchUpdates.vue?vue&type=script&lang=ts&"
export * from "./BatchUpdates.vue?vue&type=script&lang=ts&"
import style0 from "./BatchUpdates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports